import { get } from '@ember/object';
import Component from '@glimmer/component';
import type { BufferedChangeset } from 'ember-changeset/types';

export interface S {
  Element: HTMLParagraphElement;
  Args: {
    propertyName: string;
    changeset: BufferedChangeset;
    errorClass?: string;
  };
  Blocks: {
    default: [];
  };
}

export const STYLES = {
  'error-validated-input-display': 'mt-[0.2rem] text-right',
  'right-aligned-validation-error-message': 'mt-[0.2rem] absolute right-[0]',
  'left-aligned-validation-error-message': 'mt-[0.2rem] text-left',
  'error-validated-checkbox-display': 'mt-[2px] ml-[26px]'
};

export default class ValidatedField extends Component<S> {
  // Even if there are multiple errors related to `this.propertyName`, we show only one validation at a time
  // (a validation describes what was wrong with the value set on the changeset)
  get validation() {
    if (!this.args.propertyName || !this.args.changeset) return;

    const error = get(this.args.changeset.error, this.args.propertyName);

    if (!error) return undefined;

    return Array.isArray(error.validation)
      ? error.validation[0]
      : error.validation;
  }

  styles = `text-[#DB2828] _${this.args.errorClass} ${
    // @ts-expect-error Since this.args.errorClass is optional, this implementation needs to be updated
    STYLES[this.args.errorClass]
  }`;

  <template>
    {{yield}}

    {{!  Errors displayer }}
    {{#if this.validation}}
      {{! We need to specify where the local class comes from because this template lives in the `app` folder at the time of this writing }}
      {{! TODO move this component in the `addon` folder }}
      {{! eslint-disable ember/template-no-triple-curlies }}
      <p
        data-test-validation-error-for={{@propertyName}}
        class={{this.styles}}
        ...attributes
      >
        {{! @glint-expect-error }}
        {{{this.validation}}}
      </p>
    {{/if}}
  </template>
}
